// Classes
import { Range } from "../../../../containers/Filter/classes/filter.classes";

export class GPA {
  selection?: "Any" | "Specific GPA Range";
  value?: Range;

  constructor(selection?: "Any" | "Specific GPA Range", value?: Range) {
    this.selection = selection || "Any";
    this.value = value || new Range(0, 4.0);
  }
}

export class Term {
  fall?: boolean;
  spring?: boolean;

  constructor(fall?: boolean, spring?: boolean) {
    this.fall = fall || false;
    this.spring = spring || false;
  }
}

export class EntryTerm {
  selection?: "Any" | "Term-Year" | "Term" | "Year";
  value?: any | Term | Range;

  constructor(
    selection?: "Any" | "Term-Year" | "Term" | "Year",
    value?: string | Term | Range
  ) {
    this.selection = selection || "Any";
    this.value = value || undefined;
  }
}

export class TestScores {
  selection?: "Any" | "SAT" | "ACT" | "SAT or ACT" | "SAT and ACT";
  value?: {
    sat?: Range;
    act?: Range;
  };

  constructor(
    selection?: "Any" | "SAT" | "ACT" | "SAT or ACT" | "SAT and ACT",
    value?: {
      sat?: Range;
      act?: Range;
    }
  ) {
    (this.selection = selection || "Any"),
      (this.value = (value && value.sat && value.act && value) ||
        (value &&
          value.sat &&
          !value.act && {
            ...value,
            act: new Range(1, 36)
          }) ||
        (value &&
          !value.sat &&
          value.act && {
            ...value,
            sat: new Range(400, 1600)
          }) || {
          sat: new Range(400, 1600),
          act: new Range(1, 36)
        });
  }
}

export class ProspectProfileReducerState {
  intendedLevelOfStudy?: "Any" | "Undergraduate" | "Graduate";
  entryTerm?: EntryTerm;
  intendedMajor?: any[];
  gpa?: GPA;
  testScores?: TestScores;

  constructor(
    intendedLevelOfStudy?: "Any" | "Undergraduate" | "Graduate",
    entryTerm?: EntryTerm,
    intendedMajor?: any[],
    gpa?: GPA,
    testScores?: TestScores
  ) {
    this.intendedLevelOfStudy = intendedLevelOfStudy || "Any";
    this.entryTerm = entryTerm || new EntryTerm();
    this.intendedMajor = intendedMajor || [];
    this.gpa = gpa || new GPA();
    this.testScores = testScores || new TestScores();
  }
}
